// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  amplifyEnv: 'dev',
  domain: 'https://dcr-hub-dev.dna.nfl.net',
  auth: {
    hostname: 'nfl-dcr-dev-login.auth.us-east-1.amazoncognito.com',
    redirect_uri: ['https://dcr-hub-dev.dna.nfl.net/login'],
    response_type: 'code',
    client_id: '107u9mtppguoer18vmfm6t78i8',
    scope: ['openid', 'profile', 'email', 'aws.cognito.signin.user.admin'],
    user_pool_id: 'us-east-1_mOSGH9xur',
    identity_pool_id: 'us-east-1:c1adc657-37c8-489f-8c2d-31bfd954d6be',
    domain: 'dcr-hub-dev.dna.nfl.net',
  },
  api: {
    aws_appsync_graphqlEndpoint: 'https://d32rm7npwo1peo.cloudfront.net/graphql',
    aws_appsync_region: 'us-east-1',
    aws_appsync_authenticationType: 'userPool',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
